/* import __COLOCATED_TEMPLATE__ from './saml-workspace-picker.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();